module.exports = __webpack_public_path__ + "static/face-1-181aa2635a6c156e3b779e7d16ff64ec.png";